"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LoadingItem = ({ example, full }) => {
    return (0, jsx_runtime_1.jsx)("span", { className: `placeholder${full ? ' col-12' : ''}`, children: example });
};
exports.LoadingItem = LoadingItem;
